var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOperationManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.917,
    height: 32.977,
    viewBox: "0 0 32.917 32.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-operation-management",
    transform: "translate(-352 17706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(360.907 -17697.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M41.7,45.6H55.007v6.974H41.7Z",
    transform: "translate(-40.658 -41.351)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M55.791,40.861v3.607a.548.548,0,0,1-.561.561H40.961a.548.548,0,0,1-.561-.561V40.861a.548.548,0,0,1,.561-.561H55.23A.675.675,0,0,1,55.791,40.861Zm-.561,4.81H40.961a.548.548,0,0,0-.561.561h0v3.607a.548.548,0,0,0,.561.561H55.23a.548.548,0,0,0,.561-.561V46.232a.6.6,0,0,0-.561-.561Zm0,5.371H40.961a.548.548,0,0,0-.561.561V55.21a.548.548,0,0,0,.561.561H55.23a.548.548,0,0,0,.561-.561V51.6a.548.548,0,0,0-.561-.561Z",
    transform: "translate(-40.4 -40.3)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M49.9,41.4h6.974v3.046H49.9Zm0,8.417h6.974V46.771H49.9Zm0,5.371h6.974V52.142H49.9Z",
    transform: "translate(-42.285 -40.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M42.8,42.4a.8.8,0,1,1-.8.8h0A.8.8,0,0,1,42.8,42.4ZM42,48.492a.8.8,0,1,0,.8-.8h0A.8.8,0,0,0,42,48.492Zm0,5.371a.8.8,0,1,0,.8-.8h0a.8.8,0,0,0-.8.8Z",
    transform: "translate(-40.717 -40.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M46.3,42.4a.8.8,0,1,1-.8.8h0A.757.757,0,0,1,46.3,42.4Zm-.8,6.092a.8.8,0,1,0,.8-.8h0A.757.757,0,0,0,45.5,48.492Zm0,5.371a.8.8,0,1,0,.8-.8h0a.757.757,0,0,0-.8.8Z",
    transform: "translate(-41.412 -40.717)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M18.852,32.976H14.064A1.105,1.105,0,0,1,12.987,31.9V30.044a15.269,15.269,0,0,1-3.351-1.377L8.02,30.283a1.106,1.106,0,0,1-.778.359,1.106,1.106,0,0,1-.778-.359L3.172,27.051a1.022,1.022,0,0,1,0-1.556l1.556-1.556a11.533,11.533,0,0,1-1.556-3.531H1.077A1.105,1.105,0,0,1,0,19.33V14.6a1.121,1.121,0,0,1,1.077-1.077H3.052A12.676,12.676,0,0,1,4.488,9.814L3.052,8.378a1.021,1.021,0,0,1,0-1.556L6.344,3.471a1.106,1.106,0,0,1,.778-.359,1.106,1.106,0,0,1,.778.359L9.276,4.847a13.721,13.721,0,0,1,3.771-1.5V1.077A1.105,1.105,0,0,1,14.124,0h4.668a1.105,1.105,0,0,1,1.077,1.077V3.351a11.962,11.962,0,0,1,3.591,1.556l1.675-1.675a1.022,1.022,0,0,1,1.556,0l3.292,3.291a1.021,1.021,0,0,1,0,1.556L28.249,9.814a16.156,16.156,0,0,1,1.376,3.591h2.1c.464,0,.912.425,1.2,1.136v4.729a1.105,1.105,0,0,1-1.077,1.077H29.745A12.951,12.951,0,0,1,28.308,23.7l1.736,1.8a1.021,1.021,0,0,1,0,1.556l-3.291,3.291a1.022,1.022,0,0,1-1.556,0l-1.736-1.736a15.188,15.188,0,0,1-3.531,1.437V31.9A1.105,1.105,0,0,1,18.852,32.976ZM16.458,4.8A11.691,11.691,0,1,0,28.15,16.488,11.7,11.7,0,0,0,16.458,4.8Z",
    transform: "translate(352 -17706)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOperationManagement);
export default __webpack_public_path__ + "static/media/icon-operation-management.6c50b08b3b85fe7e9d973e91f248cd49.svg";
export { ForwardRef as ReactComponent };